// src/components/Services.jsx
import React, { useContext } from "react";
import { GlobalContext } from "../GlobalContext";
import { motion } from "framer-motion";

const Services = () => {
  const { content, loading } = useContext(GlobalContext);

  if (loading) return <p>جارِ التحميل...</p>;

  // 🧩 استدعاء بيانات قسم الخدمات
  const servicesData = content.services || {};

  // 🧠 تحويل الحقول إلى Array من الخدمات
  const services = Object.keys(servicesData)
    .filter((key) => key.includes("_title"))
    .map((key, i) => {
      const index = i + 1;
      return {
        icon: servicesData[`service_${index}_icon`] || "fa-solid fa-circle-question",
        title: servicesData[`service_${index}_title`] || "عنوان الخدمة",
        desc: servicesData[`service_${index}_desc`] || "وصف الخدمة غير متوفر حاليًا.",
      };
    });

  return (
    <section id="services" className="values__section">
      <motion.h1
        className="hero__title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        خدماتنا
      </motion.h1>

      <motion.p
        className="values__text"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.2 }}
        viewport={{ once: true }}
      >
        نقدم مجموعة من الخدمات التقنية لتطوير الأعمال والتحول الرقمي بطرق
        حديثة وفعالة.
      </motion.p>

      <div className="services__grid">
        {services.length > 0 ? (
          services.map((service, i) => (
            <motion.div
              key={i}
              className="service__card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <i className={service.icon}></i>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))
        ) : (
          <p>لا توجد خدمات مضافة حالياً</p>
        )}
      </div>
    </section>
  );
};

export default Services;
